import CryptoJS from "crypto-js";


export default class OnlineEncodeDecodeService {
    static generateEncryptionKeyForOTP = () => {
        var date = new Date();
        var components = [
            date.getYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
            date.getMilliseconds()
        ];

        return (components.join("") + Math.random()).replace(".", "");
    }

    static decryptForOTP(encData, decKey) {
        if (encData && encData.length && decKey && decKey.length) {
            try {
                encData = encData.trim().replace('"', "");
                decKey = decKey.trim().replace('"', "");
                var string = JSON.parse(
                    CryptoJS.DES.decrypt(
                        encData.replace('"', ""),
                        CryptoJS.enc.Utf8.parse(decKey),
                        {
                            mode: CryptoJS.mode.ECB,
                            padding: CryptoJS.pad.Pkcs7
                        }
                    ).toString(CryptoJS.enc.Utf8)
                );
                return JSON.stringify(string);
            } catch (err) {
                console.log("Either Encryption key or encryption data is invalid.");
            }
        } else {
            console.log("Either encryption key or encryption data is missing!!!");
        }
    }

    static encryptDataToSHAString(data, key) {
        var string = CryptoJS.DES.encrypt(data,
            CryptoJS.enc.Utf8.parse(key), {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
        return string;
    }

}

